import {fetchTask} from '@github-ui/agent-sessions/hooks/use-task'
import {type QueryClient, useQuery} from '@github-ui/react-query'

export const persistedTaskTitleQueryKey = (taskId?: string, apiURL?: string) =>
  ['quick-chat-persisted-task-title', taskId, apiURL] as const

export async function seedPersistedTaskTitle({
  queryClient,
  taskId,
  apiURL,
  title,
}: {
  queryClient: QueryClient
  taskId: string
  apiURL?: string
  title: string | null | undefined
}) {
  const durableTitle = title?.trim()
  if (!durableTitle) return

  const queryKey = persistedTaskTitleQueryKey(taskId, apiURL)
  await queryClient.cancelQueries({queryKey})
  queryClient.setQueryData<string | null>(queryKey, currentTitle =>
    currentTitle?.trim() ? currentTitle : durableTitle,
  )
}

export function usePersistedTaskTitle(taskId: string | undefined, apiURL?: string): string | undefined {
  const {data} = useQuery({
    queryKey: persistedTaskTitleQueryKey(taskId, apiURL),
    queryFn: async ({signal}) => {
      if (!taskId) throw new Error('taskId is required')
      const task = await fetchTask({taskId, signal, apiURL})
      return task.name?.trim() || null
    },
    enabled: !!taskId,
    staleTime: 30_000,
  })
  return data ?? undefined
}
